import React, { useContext, useEffect, useState } from "react";
import { useAuth } from "./AuthProvider";
import Theme from "../models/Theme";
import ThemeController from "../controllers/ThemeController";

const baseTheme = {
    name: "Default",
    font: "Open Sans",
    colors: {
        "--widget-color": "#ffffff", 
        "--item-color": "#f6f6f6", 
        "--modal-color": "#ffffff", 
        "--text-color": "#3c3c3c", 
        "--text-btn-color": "#ffffff", 

        "--header-background-color": "#ffffff", 
        "--sidebar-background-color": "#ffffff", 
        "--content-background-color": "#f6f6f6", 

        "--border-color": "#d3d3d3", 
        "--hover-color": "#eee", 
        "--active-color": "#badaff", 

        "--primary-color": "#257de1", 
        "--primary-color-hover": "#005fcc", 
        "--primary-highlight-color": "#005fcc", 

        "--secondary-color": "#fc0e0e", 
        "--secondary-color-hover": "#d70000", 
        "--secondary-highlight-color": "#d70000", 

        "--tertiary-color": "#b6b6b6", 
        "--tertiary-color-hover": "#a8a8a8", 
        "--tertiary-highlight-color": "#a8a8a8", 
    },
} as Theme;


type ThemeContext = {
    reloadTheme: () => void;
    baseTheme: Theme;
}

const themeContext = React.createContext<ThemeContext>({baseTheme} as ThemeContext);

const ThemeProvider = ({ children }: { children: React.ReactNode }) => {
    const {user} = useAuth();
    const [loading, setLoading] = useState(true);

    const [font, setFont] = useState<string>("");

    const updateCSSTheme = (theme: {colors: Theme["colors"]} & {font: Theme["font"]}) => {
        setFont(theme.font)
        Object.entries(theme.colors).forEach(([key, value]) => {
            document.documentElement.style.setProperty(key, value);
        });
    }

    const reloadTheme = () => {
        if(!user) return;
        ThemeController.getSelectedTheme(user.uid).then(out => {
            if(out) updateCSSTheme(out);
            else updateCSSTheme(baseTheme);
            setLoading(false);
        })  
    }


    useEffect(() => {
        reloadTheme();   
    }, [])

    if(loading) return <p>Loading...</p>;
    return (
        <themeContext.Provider value={{reloadTheme, baseTheme}}>
            <link rel="stylesheet" href={`https://fonts.googleapis.com/css2?family=${font.split(" ").join("+")}`}/>
            <div style={{fontFamily: font, backgroundColor: "var(--content-background-color)", width: "calc(100% - 200px)", height: "100%", padding: 30, overflowY: "auto", overflowX: "hidden"}}>
                {children}
            </div>
        </themeContext.Provider>
    );   
}

const useTheme = () => useContext(themeContext);
export { ThemeProvider, useTheme };